import { HOTEL } from "@/data/hotel";

// Hotel Ambica Palace — Marwon Group portfolio.
// Address: A1/300, Safdarjung Enclave, New Delhi — 110029 · 18 rooms · Near AIIMS Hospital.
export const AMBICA_IMAGES = {
  exterior: "/images/654641ee92c1.webp",
  lobby: "/images/3049a7805984.webp",
  room1: "/images/b8200cc0a6a4.webp",
  room2: "/images/1eb441bcf5b5.webp",
  room3: "/images/132735b0569a.webp",
  room4: "/images/0a20dc82d8d0.webp",
  room5: "/images/ba017bd90880.webp",
};

export const AMBICA_GALLERY = [
  AMBICA_IMAGES.exterior,
  AMBICA_IMAGES.room1,
  AMBICA_IMAGES.lobby,
  AMBICA_IMAGES.room2,
  AMBICA_IMAGES.room3,
  AMBICA_IMAGES.room4,
  AMBICA_IMAGES.room5,
];

// Both hotel properties owned by the group.
export const PROPERTIES = [
  {
    slug: "hotel-azulo-inn",
    name: "Hotel Azulo Inn",
    kind: "Boutique Hotel",
    location: "B1/16, Safdarjung Enclave · New Delhi 110029",
    rooms: "14 rooms · Premium & Premium Twin",
    blurb:
      "A boutique hotel with fourteen warmly lit rooms, a lush garden lawn, and an in-house restaurant at a minute's walk from Bhikaji Cama Place metro.",
    image: HOTEL.images.exterior,
    href: "/rooms",
    external: false,
  },
  {
    slug: "hotel-ambica-palace",
    name: "Hotel Ambica Palace",
    kind: "Boutique Hotel",
    location: "A1/300, Safdarjung Enclave · New Delhi 110029",
    rooms: "18 rooms · Near AIIMS Hospital",
    blurb:
      "Set in Safdarjung Enclave, a short walk from AIIMS Hospital and Safdarjung Hospital. Eighteen contemporary rooms with warm lighting, pristine en-suite bathrooms, and considered service — ideal for medical travellers, business executives, and extended family stays.",
    image: AMBICA_IMAGES.exterior,
    gallery: AMBICA_GALLERY,
    href: "/properties#ambica",
    external: false,
  },
];
